import React from "react";
import { Button, Modal } from "antd";

const TermsConditionsModal = ({ open, onClose }) => {
  return (
                  <Modal
                    title="Terms & Conditions"
                    open={open}
                    onOk={onClose}
                    onCancel={onClose}
                    footer={[
                      <Button
                        key="close"
                        type="primary"
                        onClick={onClose}
                      >
                        Close
                      </Button>,
                    ]}
                    width={800} // or 900 if you want more breathing room
                    centered
                  >
                    <div
                      style={{
                        maxHeight: "65vh",
                        overflowY: "auto",
                        paddingRight: "12px",
                        fontSize: "15px",
                        lineHeight: "1.6",
                      }}
                    >
                      <h2 style={{ textAlign: "center", marginBottom: "24px" }}>
                        BajCan Terms and Conditions
                      </h2>

                      <p
                        style={{
                          fontStyle: "italic",
                          textAlign: "center",
                          marginBottom: "32px",
                        }}
                      >
                        Effective Date: March 10, 2026
                      </p>

                      <p>
                        These Terms and Conditions ("Terms") govern your use of
                        the BajCan website, mobile applications, and remittance
                        services (collectively referred to as the "Services").
                      </p>
                      <p>
                        By accessing or using BajCan, you agree to comply with
                        and be bound by these Terms. If you do not agree with
                        these Terms, you must not use the Services.
                      </p>

                      <h3>1. About BajCan</h3>
                      <p>
                        BajCan is a digital remittance platform designed to
                        connect individuals in Canada with recipients in
                        Barbados and other Caribbean destinations. The platform
                        enables users to transfer money securely through
                        licensed financial partners and payment processors.
                      </p>
                      <p>
                        BajCan provides the technology infrastructure that
                        facilitates these transactions and works with regulated
                        financial institutions to complete payment processing.
                      </p>

                      <h3>2. Eligibility to Use the Services</h3>
                      <p>To use BajCan Services, you must:</p>
                      <ul>
                        <li>Be at least 18 years of age</li>
                        <li>
                          Have legal capacity to enter into binding agreements
                        </li>
                        <li>
                          Provide accurate and truthful information during
                          registration
                        </li>
                        <li>
                          Comply with all applicable laws and financial
                          regulations
                        </li>
                      </ul>
                      <p>
                        BajCan reserves the right to refuse service to any
                        individual or entity at its sole discretion,
                        particularly where regulatory or compliance concerns
                        arise.
                      </p>

                      <h3>3. User Accounts</h3>
                      <p>
                        To access certain features of the BajCan platform, you
                        must create an account.
                      </p>
                      <p>When registering for an account, you agree to:</p>
                      <ul>
                        <li>Provide accurate and complete information</li>
                        <li>Maintain the security of your login credentials</li>
                        <li>
                          Notify BajCan immediately if unauthorized access to
                          your account occurs
                        </li>
                        <li>
                          Ensure that your account information remains current
                        </li>
                      </ul>
                      <p>
                        You are solely responsible for all activities that occur
                        under your account.
                      </p>

                      <h3>4. Identity Verification (KYC Requirements)</h3>
                      <p>
                        To comply with financial regulations including
                        anti-money laundering (AML) requirements, BajCan may
                        require identity verification before allowing users to
                        send money.
                      </p>
                      <p>Verification may include:</p>
                      <ul>
                        <li>Government-issued identification</li>
                        <li>Proof of address</li>
                        <li>Selfie or biometric verification</li>
                        <li>Source of funds information</li>
                        <li>
                          Additional documentation as required by regulators
                        </li>
                      </ul>
                      <p>
                        BajCan reserves the right to delay, reject, or cancel
                        transactions until verification requirements are
                        satisfied.
                      </p>

                      <h3>5. Sending Money Through BajCan</h3>
                      <p>
                        Users may initiate money transfers through the BajCan
                        website or mobile application.
                      </p>
                      <p>
                        When initiating a transfer, users must provide accurate
                        information including:
                      </p>
                      <ul>
                        <li>Recipient name</li>
                        <li>Recipient bank or payout details</li>
                        <li>Destination country</li>
                        <li>Transfer amount</li>
                      </ul>
                      <p>
                        The user is responsible for ensuring that all
                        information provided is correct.
                      </p>
                      <p>
                        BajCan is not responsible for transfers sent to
                        incorrect recipients due to inaccurate information
                        supplied by the sender.
                      </p>

                      <h3>6. Transaction Processing</h3>
                      <p>Once a transfer request is submitted:</p>
                      <ul>
                        <li>
                          BajCan will process the request through its financial
                          partners
                        </li>
                        <li>
                          Funds will be transferred according to the selected
                          payout method
                        </li>
                        <li>
                          Delivery times may vary depending on banking systems,
                          compliance reviews, and local payment networks
                        </li>
                      </ul>
                      <p>
                        Certain transfers may be delayed for compliance or fraud
                        prevention reviews.
                      </p>

                      <h3>7. Fees and Exchange Rates</h3>
                      <p>
                        BajCan may charge transaction fees for remittance
                        services.
                      </p>
                      <p>Fees may vary depending on:</p>
                      <ul>
                        <li>Payment method</li>
                        <li>Transfer amount</li>
                        <li>Destination country</li>
                        <li>Currency exchange rate</li>
                      </ul>
                      <p>
                        Users will be shown the total cost of the transaction,
                        including fees and exchange rate information, before
                        confirming the transfer.
                      </p>
                      <p>
                        Exchange rates may fluctuate based on market conditions.
                      </p>

                      <h3>8. Payment Methods</h3>
                      <p>
                        Users may fund transactions using supported payment
                        methods, which may include:
                      </p>
                      <ul>
                        <li>Bank transfers</li>
                        <li>Debit cards</li>
                        <li>Credit cards</li>
                        <li>Other approved payment channels</li>
                      </ul>
                      <p>
                        Payment methods are subject to verification and may be
                        restricted based on risk assessment.
                      </p>

                      <h3>9. Transaction Limits</h3>
                      <p>BajCan may impose limits on:</p>
                      <ul>
                        <li>Maximum transfer amounts</li>
                        <li>Daily or monthly transaction volume</li>
                        <li>Number of transfers</li>
                      </ul>
                      <p>Limits may depend on:</p>
                      <ul>
                        <li>Account verification level</li>
                        <li>Regulatory requirements</li>
                        <li>Risk monitoring policies</li>
                      </ul>
                      <p>
                        BajCan may adjust limits without prior notice if
                        required by law or security considerations.
                      </p>

                      <h3>10. Compliance With Financial Regulations</h3>
                      <p>
                        BajCan complies with applicable financial regulations
                        including anti-money laundering and anti-terrorism
                        financing laws.
                      </p>
                      <p>To ensure compliance, BajCan may:</p>
                      <ul>
                        <li>Monitor transactions for suspicious activity</li>
                        <li>Request additional documentation</li>
                        <li>
                          Report suspicious transactions to relevant authorities
                        </li>
                      </ul>
                      <p>
                        Users agree not to use the platform for any unlawful
                        purpose.
                      </p>

                      <h3>11. Prohibited Activities</h3>
                      <p>Users may not use BajCan Services for:</p>
                      <ul>
                        <li>Fraud or financial scams</li>
                        <li>Money laundering</li>
                        <li>Terrorism financing</li>
                        <li>Illegal goods or services</li>
                        <li>
                          Gambling or restricted industries where prohibited by
                          law
                        </li>
                        <li>Attempting to circumvent regulatory controls</li>
                      </ul>
                      <p>
                        Violation of these rules may result in immediate
                        suspension or termination of the account.
                      </p>

                      <h3>12. Fraud Prevention and Security</h3>
                      <p>
                        BajCan employs advanced fraud detection systems to
                        protect users.
                      </p>
                      <p>Security measures may include:</p>
                      <ul>
                        <li>Transaction monitoring</li>
                        <li>Identity verification checks</li>
                        <li>Behavioral analysis</li>
                        <li>Temporary holds on suspicious transfers</li>
                      </ul>
                      <p>
                        Users must immediately notify BajCan if they suspect
                        fraudulent activity on their account.
                      </p>

                      {/* Continue with remaining sections in the same pattern */}

                      <h3>13. Service Availability</h3>
                      <p>
                        BajCan strives to maintain reliable service, however
                        uninterrupted availability cannot be guaranteed.
                      </p>
                      <p>Service interruptions may occur due to:</p>
                      <ul>
                        <li>Scheduled maintenance</li>
                        <li>Security updates</li>
                        <li>Network failures</li>
                        <li>Third-party provider issues</li>
                      </ul>
                      <p>
                        BajCan is not liable for service interruptions outside
                        its control.
                      </p>

                      <h3>14. Mobile Application Use</h3>
                      <p>
                        BajCan offers mobile applications for iOS and Android
                        devices.
                      </p>
                      <p>By using the BajCan mobile apps, users agree:</p>
                      <ul>
                        <li>
                          To install updates when required for security or
                          functionality
                        </li>
                        <li>Not to reverse engineer or modify the software</li>
                        <li>To use the app only on supported devices</li>
                      </ul>
                      <p>
                        App store providers such as Apple and Google may have
                        additional terms governing app usage.
                      </p>

                      <h3>15. Third-Party Service Providers</h3>
                      <p>
                        BajCan works with third-party partners to deliver
                        certain services, including:
                      </p>
                      <ul>
                        <li>Payment processing</li>
                        <li>Identity verification</li>
                        <li>Fraud detection</li>
                        <li>Banking and settlement services</li>
                      </ul>
                      <p>
                        While BajCan selects reputable partners, it cannot
                        control all actions taken by third-party providers.
                      </p>

                      <h3>16. Limitation of Liability</h3>
                      <p>
                        To the maximum extent permitted by law, BajCan is not
                        liable for:
                      </p>
                      <ul>
                        <li>Indirect or consequential losses</li>
                        <li>
                          Losses caused by incorrect recipient information
                        </li>
                        <li>Banking delays or errors by financial partners</li>
                        <li>Exchange rate fluctuations</li>
                        <li>Technical failures outside BajCan systems</li>
                      </ul>
                      <p>
                        BajCan's liability in connection with any transaction
                        shall not exceed the amount of that transaction.
                      </p>

                      <h3>17. Account Suspension and Termination</h3>
                      <p>
                        BajCan reserves the right to suspend or terminate
                        accounts where:
                      </p>
                      <ul>
                        <li>Fraudulent activity is suspected</li>
                        <li>These Terms are violated</li>
                        <li>Regulatory compliance issues arise</li>
                        <li>Identity verification cannot be completed</li>
                      </ul>
                      <p>Users may also request account closure at any time.</p>
                      <p>
                        Certain information may still be retained to comply with
                        regulatory obligations.
                      </p>

                      <h3>18. Intellectual Property</h3>
                      <p>
                        All BajCan technology, branding, content, and design
                        elements are the intellectual property of BajCan.
                      </p>
                      <p>
                        Users may not copy, distribute, modify, or reproduce
                        BajCan materials without written permission.
                      </p>

                      <h3>19. Privacy and Data Protection</h3>
                      <p>
                        Your use of BajCan Services is also governed by the
                        BajCan Privacy Policy.
                      </p>
                      <p>
                        By using BajCan, you consent to the collection and use
                        of information as described in that policy.
                      </p>

                      <h3>20. Governing Law</h3>
                      <p>
                        These Terms shall be governed by and interpreted
                        according to the laws of Canada and the applicable
                        province in which BajCan operates.
                      </p>
                      <p>
                        Any disputes shall be resolved in the courts of Canada.
                      </p>

                      <h3>21. Changes to the Terms</h3>
                      <p>
                        BajCan reserves the right to modify these Terms at any
                        time.
                      </p>
                      <p>
                        Updated Terms will be posted on the BajCan website and
                        mobile applications.
                      </p>
                      <p>
                        Continued use of the Services following updates
                        constitutes acceptance of the revised Terms.
                      </p>

                      <h3>22. Contact Information</h3>
                      <p>
                        If you have questions regarding these Terms and
                        Conditions, please contact:
                      </p>
                      <ul>
                        <li>BajCan Support</li>
                        <li>
                          Email:{" "}
                          <a href="mailto:info@bajcan.com">info@bajcan.com</a>
                        </li>
                        <li>
                          Website:{" "}
                          <a
                            href="https://www.bajcan.com"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            www.bajcan.com
                          </a>
                        </li>
                      </ul>

                      <p
                        style={{
                          marginTop: "32px",
                          fontSize: "14px",
                          color: "#555",
                          textAlign: "center",
                        }}
                      >
                        Thank you for using BajCan.
                      </p>
                    </div>
                  </Modal>
  );
};

export default TermsConditionsModal;
